import { PokalColor } from "pokal_api"

class PokalColorConverter {
    static toBadge(color: PokalColor): string {
        switch (color) {
            case "amber":
                return "bg-amber-200 font-bold text-amber-900 py-1 px-2 text-[10px] rounded-xl tracking-widest"
            case "red":
                return "bg-rose-200 font-bold text-rose-900 py-1 px-2 text-[10px] rounded-xl tracking-widest"
            case "emerald":
                return "bg-emerald-200 font-bold text-emerald-900 py-1 px-2 text-[10px] rounded-xl tracking-widest"
            case "lime":
                return "bg-lime-200 font-bold text-lime-900 py-1 px-2 text-[10px] rounded-xl tracking-widest"
            case "orange":
                return "bg-orange-200 font-bold text-orange-900 py-1 px-2 text-[10px] rounded-xl tracking-widest"
            case "yellow":
                return "bg-yellow-200 font-bold text-yellow-900 py-1 px-2 text-[10px] rounded-xl tracking-widest"
            case "neutral":
                return "bg-neutral-200 font-bold text-neutral-900 py-1 px-2 text-[10px] rounded-xl tracking-widest"
        }
    }
    static toTopBorder(color: PokalColor): string {
        switch (color) {
            case "amber":
                return "border-t-4 border-t-amber-600"
            case "red":
                return "border-t-4 border-t-rose-600"
            case "emerald":
                return "border-t-4 border-t-emerald-600"
            case "lime":
                return "border-t-4 border-t-lime-600"
            case "orange":
                return "border-t-4 border-t-orange-600"
            case "yellow":
                return "border-t-4 border-t-yellow-600"
            case "neutral":
                return "border-t-4 border-t-neutral-600"
        }
    }
}

export default PokalColorConverter
